import React from "react";
import { CancelButton } from "../util/CancelButton";

export const LoadingPage = ({ loadingText, OnCancel }) => {
    const CancelLoading = () => {
        console.log("canceled loading");
        if (OnCancel) OnCancel();
    };

    return (
        <div>
            <div className="center center-boarder">
                <div className="bottle-loader">
                    <div className="bubble"></div>
                    <div className="bubble"></div>
                    <div className="bubble"></div>
                </div>
                <br />
                <p>{loadingText}</p>
            </div>
            <CancelButton onClick={CancelLoading} />
        </div>
    );
};